import type { JSX } from 'react'

export const VisaCardIcon = (): JSX.Element => (
  <use href='#visaCard' height='100%' width='100%' />
)
